var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 295.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_flat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "     M400.5,248.9     V396.1     L528,469.7     l127.5-73.6     V248.9     L528,175.3     Zm62-35.9",
    transform: "translate(-400 -174.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHexagon);
export default __webpack_public_path__ + "static/media/logo_hexagon.ff5fb72fd37ced4a941a8389b4c3a4d1.svg";
export { ForwardRef as ReactComponent };